<template>
  <div>
    <div class="topBack">
      <i class="iconfont iconback" @click="onTopBack" />
    </div>
    <div class="topImg">
      <img src="/img/hbup.jpg" class="back">
      <img src="/img/hbdownsmall.jpg" class="back">
      <div v-if="data" class="info">
        <van-row>
          <van-col span="8" class="about">我的抽奖号</van-col>
          <van-col span="16" class="textRight">9~20点每个小时准点开奖</van-col>
        </van-row>
        <div v-if="!data.isLuck" class="talk">
          {{ data.code }}
        </div>
        <div v-if="data.isLuck" class="talk">
          已中奖[{{ data.title }}]
        </div>
      </div>
      <div v-if="!data" class="info">
        <van-row>
          <van-col span="8" class="about">我的抽奖号</van-col>
          <van-col span="16" class="textRight">展会周末12~17点每个小时准点开奖</van-col>
        </van-row>
        <div class="talk">
          尚未获得
        </div>
      </div>
    </div>
    <div class="listRect">
      <div v-for="item in list" :key="item.code" class="listLine">
        <van-row>
          <van-col span="8">{{ item.title }}</van-col>
          <van-col span="8">{{ item.name }}</van-col>
          <van-col span="8">{{ item.phone }}</van-col>
        </van-row>
      </div>
    </div>
    <div class="emptyRect" />
    <div class="downButton">
      <van-button type="info" square @click="onActivity">立即交叉认证卡片获得抽奖资格</van-button>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { getUrlKey, initPage } from '@/utils/base'
import { Button } from 'vant'
export default {
  components: {
    [Button.name]: Button
  },
  data() {
    return {
      backurl: '/activity/raffle',
      list: [],
      data: undefined
    }
  },
  mounted() {
    initPage(true)
    request({
      url: '/Activity/getLuckUserCard',
      method: 'post'
    }).then(response => {
      if (!response.success) {
        return
      }
      this.list = response.data
    })
    request({
      url: '/Activity/getMyLuckUserCard',
      method: 'post'
    }).then(response => {
      if (!response.success) {
        return
      }
      this.data = response.data
    })
  },
  created() {
    initPage(true)
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
  },
  methods: {
    onTopBack() {
      this.$router.replace('/activity/raffle')
    },
    onActivity() {
      this.$router.replace('/activity/raffle')
    }
  }
}
</script>
<style scoped>
.listRect
{
padding: 1em 1em;
}
.listRect .listLine{
  margin: 0.4em 0 ;
}
.topBack{
  z-index: 100;
  position: absolute;
  left:1em;
  top: 1em;
  color: #fff;
}

.back{
  width: 100%;
  margin: 0;
  padding: 0;
  vertical-align:top;
}
.topImg{
    position: relative;
}
.topImg .info{
  position:absolute;
  height: 5em;
  bottom: 1em;
  left: 2em;
  right: 2em;
  color: #fff;
  font-size: 0.9em;
}
.topImg .talk{
    margin: 0.5em 0;
    padding: 0 1em;
    text-align: center;
    line-height: 1.8em;
    font-size: 1.6em;
    background-color: #E32119;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.emptyRect{
  height: 3em;
}
.downButton{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 42px;
}
.downButton button{
  background-color: #0092FA;
  border: #0092FA;
  width: 100%;
}
</style>
